export default (width = 24, height = 24) => `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10.5" fill="none" stroke="#E6E6E6" stroke-width="3"/>
    </svg>
`